<template>
	<div
		:class="displayUnverifiedUserAlert ? 'display-alert' : ''"
		class="app header-primary"
	>
		<unverified-user-alert :display="displayUnverifiedUserAlert" />
		<div class="layout">
			<sidebar-module v-if="!isTermosUsoPage" />
			<navbar-module v-if="!isTermosUsoPage" />
			<div class="page-container" :style="pageContainerStyle">
				<div class="main-content">
					<div class="container-fluid">
						<router-view />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import UnverifiedUserAlert from "../../components/alerts/UnverifiedUserAlert";

export default {
	name: "Dashboard",
	components: { UnverifiedUserAlert },
	metaInfo() {
		return {
			title: "Painel do Técnico: " + this.$store.state.user.name,
		};
	},
	mounted() {
		this.$store.dispatch("setSettingSuporte");
	},
	computed: {
		displayUnverifiedUserAlert() {
			if (
				this.$store.state.settings.unverified_user_alert &&
				this.$store.state.user
			) {
				return !this.$store.state.user.verified;
			}
			return false;
		},
		isTermosUsoPage() {
			return this.$route.path === '/dashboard/termos-de-uso';
		},
		pageContainerStyle() {
			return this.isTermosUsoPage 
				? 'padding: 0px;' 
				: 'padding-top: 65px';
		}
	},
};
</script>

<style>
.page-container .main-content {
	padding: 25px 15px 25px 15px !important;
}
</style>
